// src/keycloak.js
import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: "medmaze",
  clientId: "medmaze-spa",
});

export default keycloak;
